import React, { useState } from 'react';
import Modal from './ui/Modal';
import { Project } from '../types';
import { useTranslation } from '../hooks/useTranslation';

interface ProjectAssignmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  projects: Project[];
  artistCount: number;
  onAssign: (projectId: string) => void;
}

const ProjectAssignmentModal: React.FC<ProjectAssignmentModalProps> = ({
  isOpen,
  onClose,
  projects,
  artistCount,
  onAssign
}) => {
  const { t } = useTranslation();
  const [selectedProjectId, setSelectedProjectId] = useState('');

  const handleSubmit = () => {
    if (selectedProjectId) {
      onAssign(selectedProjectId);
      setSelectedProjectId('');
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('projectAssignment.assignTo')}
    >
      <div className="space-y-4">
        <p className="text-gray-300">
          {t('projectAssignment.profile', { count: artistCount })}
        </p>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            {t('common.project')}
          </label>
          <select
            value={selectedProjectId}
            onChange={(e) => setSelectedProjectId(e.target.value)}
            className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-indigo-500"
          >
            <option value="">{t('common.select')}</option>
            {projects.map(project => (
              <option key={project.id} value={project.id}>
                {project.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
          >
            {t('common.cancel')}
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={!selectedProjectId}
            className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {t('projectAssignment.assign')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ProjectAssignmentModal;


